/**
 * App-shell sidebar: mobile off-canvas drawer + active-state sync for the
 * dashboard view links (Dashboard / Action items / Archive), which switch
 * client-side via history.pushState on the dashboard page.
 */
(function () {
  "use strict";

  var sidebar = document.getElementById("app-sidebar");
  if (!sidebar) return;

  var toggle = document.getElementById("app-sidebar-toggle");
  var backdrop = document.getElementById("app-sidebar-backdrop");
  var openClass = "app-sidebar-open";

  function isOpen() {
    return document.body.classList.contains(openClass);
  }

  function setOpen(open) {
    document.body.classList.toggle(openClass, open);
    if (toggle) {
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close navigation" : "Open navigation");
    }
  }

  if (toggle) {
    toggle.addEventListener("click", function () {
      setOpen(!isOpen());
    });
  }

  if (backdrop) {
    backdrop.addEventListener("click", function () {
      setOpen(false);
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen()) {
      setOpen(false);
      if (toggle) toggle.focus();
    }
  });

  // Close the drawer when a nav link is chosen (navigation happens anyway, but
  // same-page links like /dashboard?view=actions can be intercepted by page JS).
  sidebar.addEventListener("click", function (e) {
    if (e.target.closest("a") && isOpen()) {
      setOpen(false);
    }
  });

  // ── Active-state sync for dashboard view links ──
  // Only the dashboard switches views client-side (via history.pushState), so the
  // history wrap installs solely there; every other page keeps native history.
  // Client-side view switching (Brief / All / Actions / Archive) now happens on the Brief page.
  var onBriefPage = window.location.pathname.replace(/\/+$/, "") === "/dashboard/brief";
  var viewLinks = sidebar.querySelectorAll("[data-sidebar-match]");
  if (!onBriefPage || viewLinks.length === 0) return;

  var briefParentLink = sidebar.querySelector('.app-sidebar-parent-link[data-sidebar-match="brief:digest"]');

  function currentDashboardMatch() {
    var view = (new URLSearchParams(window.location.search).get("view") || "").toLowerCase();
    if (view === "actions") return "brief:actions";
    if (view === "archived") return "brief:archived";
    return "brief:digest";
  }

  function syncActive() {
    var match = currentDashboardMatch();
    var hasMatchingLink = Array.prototype.some.call(viewLinks, function (link) {
      return link.getAttribute("data-sidebar-match") === match;
    });
    // No link carries this match (e.g. Action items is plan-locked and its locked
    // variant links to upgrade instead) — leave the server-rendered state alone.
    if (!hasMatchingLink) return;

    viewLinks.forEach(function (link) {
      var isActive = link.getAttribute("data-sidebar-match") === match;
      link.classList.toggle("app-sidebar-link--active", isActive);
      if (isActive) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });

    // The Brief parent link carries a second, mutually-exclusive class (mirrors the
    // server-rendered "activeBriefGroup && !activeBrief" guard) that the generic loop
    // above doesn't know about: lit softly when a child view (Archived) is showing,
    // off when Brief itself is the active tab. Without this, client-side tab switches
    // leave it stuck with whichever class the original full page load rendered.
    if (briefParentLink) {
      briefParentLink.classList.toggle("app-sidebar-parent-link--group-active", match === "brief:archived");
    }
  }

  // The dashboard updates the URL with history.pushState/replaceState; wrap them
  // once so the sidebar hears about it, and cover back/forward via popstate.
  ["pushState", "replaceState"].forEach(function (method) {
    var original = window.history[method];
    if (typeof original !== "function") return;
    window.history[method] = function () {
      var result = original.apply(this, arguments);
      window.dispatchEvent(new Event("stackora:navigate"));
      return result;
    };
  });

  window.addEventListener("stackora:navigate", syncActive);
  window.addEventListener("popstate", syncActive);
  syncActive();
})();
